import { detectedApp, isQA } from "../api/common";
import { SourceApp, DeploymentType } from 'vbook-ui-components/src/Config';

import {
    CURRENT_APP_LIVEVIDEO,
    CURRENT_APP_LIVEPROJECT,
    LIVEVIDEO_COURSE_TYPE,
    LIVEPROJECT_COURSE_TYPE,
    USER_DISPLAY_NAME,
    AUTHOR_DISPLAY_NAME,
    EDITOR_DISPLAY_NAME,
    ADMIN_DISPLAY_NAME,
    MENTOR_DISPLAY_NAME,
    ADMIN_LIST,
    EDITOR_LIST,
    AUTHOR_LIST_SUFFIX,
    USER_LIST,
    MENTOR_LIST_SUFFIX,
    VIDEO_MODULE_TYPE,
    TEXT_MODULE_TYPE,
    EXERCISE_MODULE_TYPE,
    DELIVERABLE_MODULE_TYPE,
    PREVIEW,
    FREE,
    UNIT,
    MILESTONE,
    MODULE,
    CONTENT_MODULE,
    LIVEPROJECT_TITLE,
    LIVEVIDEO_VIEWER_MODULE_TYPE,
    CERTIFICATE_TEST_MODULE_TYPE,
    SOLO,
    MENTORED,
    FORCE_TONI_DEV,
    COURSE_FEEDBACK_MODULE_TYPE,
    ROLE_IVC_AUTHOR
} from "../constants";
import { ICourseCoverDimensions } from "../components/models/models";

declare const __LOCAL__;

class PlatformUtils {
    currentApp: string;

    constructor() {
        this.currentApp = detectedApp();
    }

    isLiveVideo() {
        return this.currentApp === CURRENT_APP_LIVEVIDEO;
    }

    isLiveProject() {
        return this.currentApp === CURRENT_APP_LIVEPROJECT;
    }

    getCurrentApp() {
        return this.currentApp;
    }

    getAppName() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "liveVideo";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "liveProject";
                break;
            default:
                return "Manning";
                break;
        }
    }

    getOriginPlatformId() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return 2;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return 3;
                break;
            default:
                return 0;
                break;
        }
    }

    shouldShowResourceIcon(): boolean {
        return this.currentApp == CURRENT_APP_LIVEPROJECT;
    }

    getHeaderDefaultUpArrowAccountRightCSSValue() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "24px";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "20px";
                break;
            default:
                return "24px";
                break;
        }
    }

    getHeaderModuleUpArrowAccountRightCSSValue(isLoggedIn: boolean) {
        if (isLoggedIn) {
            switch (this.currentApp) {
                case CURRENT_APP_LIVEVIDEO:
                    return "25px";
                    break;
                case CURRENT_APP_LIVEPROJECT:
                    return "18px";
                    break;
                default:
                    return "25px";
                    break;
            }
        } else {
            switch (this.currentApp) {
                case CURRENT_APP_LIVEVIDEO:
                    return "25px";
                    break;
                case CURRENT_APP_LIVEPROJECT:
                    return "20px";
                    break;
                default:
                    return "25px";
                    break;
            }
        }
    }

    getHeaderModuleUpArrowSettingsRightCSSValue(isLoggedIn: boolean) {
        if (isLoggedIn) {
            switch (this.currentApp) {
                case CURRENT_APP_LIVEVIDEO:
                    return "123px";
                    break;
                case CURRENT_APP_LIVEPROJECT:
                    return "215px";
                    break;
                default:
                    return "123px";
                    break;
            }
        } else {
            switch (this.currentApp) {
                case CURRENT_APP_LIVEVIDEO:
                    return "195px";
                    break;
                case CURRENT_APP_LIVEPROJECT:
                    return "164px";
                    break;
                default:
                    return "195px";
                    break;
            }
        }
    }

    getHeaderDefaultUpArrowSettingsRighCSSValue() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "123px";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "111px";
                break;
            default:
                return "123px";
                break;
        }
    }

    getLandingPageTitle() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "liveVideo landing page";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "liveProject landing page";
                break;
            default:
                return "Landing page";
                break;
        }
    }

    getLandingPageMainTitle() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "liveVideo courses from Manning";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "liveProjects from Manning";
                break;
            default:
                return "Manning courses";
                break;
        }
    }

    getManageCoursesH1Title() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "liveVideo courses";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "liveProjects";
                break;
            default:
                return "Courses";
                break;
        }
    }

    doesHaveCourseChatInsteadOfDiscussionIcon() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportGroups() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportAlwaysOpenUnits() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return true;
                break;
        }
    }

    doesSupportBeta() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    shouldShowNewLicenseDetectedModal() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    doesForceOpenProfileIfNotSubmitted() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doCheckHappyWithGroup() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportProfile() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportSkills() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportFreeCourses() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportLpLites() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportMiniLv() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportDistributedCourses() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    getCourseType() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return LIVEVIDEO_COURSE_TYPE;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return LIVEPROJECT_COURSE_TYPE;
                break;
            default:
                return LIVEVIDEO_COURSE_TYPE;
                break;
        }
    }

    doesHaveMentors() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupport1on1WithMentor() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    getListOfRoles() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return [USER_DISPLAY_NAME, AUTHOR_DISPLAY_NAME, EDITOR_DISPLAY_NAME, ADMIN_DISPLAY_NAME];
                break;
            case CURRENT_APP_LIVEPROJECT:
                return [USER_DISPLAY_NAME, AUTHOR_DISPLAY_NAME, EDITOR_DISPLAY_NAME, MENTOR_DISPLAY_NAME, ADMIN_DISPLAY_NAME];
                break;
            default:
                return [USER_DISPLAY_NAME, AUTHOR_DISPLAY_NAME, EDITOR_DISPLAY_NAME, ADMIN_DISPLAY_NAME];
                break;
        }
    }

    getListOfListTypes() {

        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return [ADMIN_LIST, EDITOR_LIST, `${this.getProductType().fullSingular}${AUTHOR_LIST_SUFFIX}`, USER_LIST];
                break;
            case CURRENT_APP_LIVEPROJECT:
                return [ADMIN_LIST, EDITOR_LIST, `${this.getProductType().fullSingular}${AUTHOR_LIST_SUFFIX}`, `${this.getProductType().fullSingular}${MENTOR_LIST_SUFFIX}`, USER_LIST];
                break;
            default:
                return [ADMIN_LIST, EDITOR_LIST, `${this.getProductType().fullSingular}${AUTHOR_LIST_SUFFIX}`, USER_LIST];
                break;
        }
    }

    doesSupportCertificateTestModule() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    doesSupportCourseFeedbackModule() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    showCourseFeedbackModuleOnlyToReviewers() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return this.doesSupportFeedbackForms() && this.doesSupportCourseFeedbackModule() && false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return this.doesSupportFeedbackForms() && this.doesSupportCourseFeedbackModule() && true;
                break;
            default:
                return false;
                break;
        }
    }

    getSupportedModuleTypes() { //doesSupportDeliverables
        let res;
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                res = [
                    VIDEO_MODULE_TYPE,
                    TEXT_MODULE_TYPE,
                    EXERCISE_MODULE_TYPE,
                    LIVEVIDEO_VIEWER_MODULE_TYPE,
                ]
                if (this.doesSupportCertificateTestModule()) {
                    res = [
                        ...res,
                        CERTIFICATE_TEST_MODULE_TYPE,
                    ]
                }
                if (this.doesSupportCourseFeedbackModule()) {
                    res = [
                        ...res,
                        COURSE_FEEDBACK_MODULE_TYPE,
                    ]
                }
                return res;
            case CURRENT_APP_LIVEPROJECT:
                res = [
                    VIDEO_MODULE_TYPE,
                    TEXT_MODULE_TYPE,
                    EXERCISE_MODULE_TYPE,
                    DELIVERABLE_MODULE_TYPE,
                    LIVEVIDEO_VIEWER_MODULE_TYPE,
                ]
                if (this.doesSupportCertificateTestModule()) {
                    res = [
                        ...res,
                        CERTIFICATE_TEST_MODULE_TYPE,
                    ]
                }
                if (this.doesSupportCourseFeedbackModule()) {
                    res = [
                        ...res,
                        COURSE_FEEDBACK_MODULE_TYPE,
                    ]
                }
                return res;
            default:
                res = [
                    VIDEO_MODULE_TYPE,
                    TEXT_MODULE_TYPE,
                    EXERCISE_MODULE_TYPE,
                    LIVEVIDEO_VIEWER_MODULE_TYPE,
                ]
                if (this.doesSupportCertificateTestModule()) {
                    res = [
                        ...res,
                        CERTIFICATE_TEST_MODULE_TYPE,
                    ]
                }
                if (this.doesSupportCourseFeedbackModule()) {
                    res = [
                        ...res,
                        COURSE_FEEDBACK_MODULE_TYPE,
                    ]
                }
                return res;
        }
    }

    doesSupportDeliverables() { // getSupportedModuleTypes
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true
                break;
            default:
                return false
                break;
        }
    }

    doesSupportSolutionArtefacts() { // getSupportedModuleTypes
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true
                break;
            default:
                return false
                break;
        }
    }

    doesSupportHelpArtefacts() { // getSupportedModuleTypes
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false
                break;
        }
    }

    doesSupportNestedHelpArtefacts() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false
                break;
        }
    }

    doesSupportLicenseTiers() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true
                break;
            default:
                return false
                break;
        }
    }

    getVbookComponentsSourceApp() { // getSupportedModuleTypes
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return SourceApp.livevideo;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return SourceApp.pbc;
                break;
            default:
                return SourceApp.livevideo;
                break;
        }
    }

    getDeploymentType() {
        var url = window.location.href;
        let deploymentType;
        if (url.indexOf("-ui-test") !== -1 || FORCE_TONI_DEV || __LOCAL__) {
            return DeploymentType.test;
        }
        else if (isQA()) {
            return DeploymentType.qa;
        }
        else {
            return DeploymentType.prod;
        }
    }

    doesSupportCriteoGTM() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return true;
                break;
        }
    }


    doesSupportSisteredLicenses() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    shouldShowDividerArrowForChat() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }


    doMentorsHaveEditRights() { // getSupportedModuleTypes
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return this.doesHaveMentors() && false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return this.doesHaveMentors() && false;
                break;
            default:
                return this.doesHaveMentors() && false;
                break;
        }
    }

    doesAllowDownloadCourse() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    does

    numerationInTocModule() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    getNoCourseCover() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return require("../resources/images/noCourse.jpg");
                break;
            case CURRENT_APP_LIVEPROJECT:
                return require("../resources/images/defaultLiveProject.svg");
                break;
            default:
                return require("../resources/images/noCourse.jpg");
                break;
        }
    }

    shouldShowBestSellers() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    doesHaveSocialInteraction() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    getFreeModuleText() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return PREVIEW;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return FREE;
                break;
            default:
                return PREVIEW;
                break;
        }
    }

    getModuleTerminology() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return MODULE;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return CONTENT_MODULE;
                break;
            default:
                return MODULE;
                break;
        }
    }

    getNameForDiscussions() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "discussions";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "project chat";
                break;
            default:
                return "discussions";
                break;
        }
    }

    doesHaveDiscussionsOnLandingPage() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    shouldReloadDiscussionsOnChange() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    getShortNameForDiscussions() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "discussions";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "chat";
                break;
            default:
                return "discussions";
                break;
        }
    }

    getUnitTerminology() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return UNIT;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return MILESTONE;
                break;
            default:
                return UNIT;
                break;
        }
    }

    areDiscussionsRealTime() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    getProductType() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return {
                    singular: "course",
                    singularCapitalized: "Course",
                    plural: "courses",
                    pluralCapitalized: "Courses",
                    fullSingular: "course",
                    fullSingularCapitalized: "Course",
                    fullPlural: "courses",
                };
                break;
            case CURRENT_APP_LIVEPROJECT:
                return {
                    singular: "project",
                    singularCapitalized: "Project",
                    plural: "projects",
                    pluralCapitalized: "Projects",
                    fullSingular: "liveProject",
                    fullSingularCapitalized: "liveProject",
                    fullPlural: "liveProjects",
                };
                break;
            default:
                return {
                    singular: "course",
                    singularCapitalized: "Course",
                    plural: "courses",
                    pluralCapitalized: "Courses",
                    fullSingular: "course",
                    fullSingularCapitalized: "Course",
                    fullPlural: "courses",
                };
                break;
        }
    }

    getTextModuleHeaderText() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return null;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return LIVEPROJECT_TITLE;
                break;
            default:
                return null;
                break;
        }
    }

    getExerciseModuleHeaderText() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "exercise";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return LIVEPROJECT_TITLE;
                break;
            default:
                return "exercise";
                break;
        }
    }

    getCertificateTestHeaderText() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return null;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "certificate test";
                break;
            default:
                return null;
                break;
        }
    }

    getDeliverableModuleHeaderText() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return null;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return LIVEPROJECT_TITLE;
                break;
            default:
                return null;
                break;
        }
    }

    getCourseFeedbackHeaderText() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return null;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return LIVEPROJECT_TITLE;
                break;
            default:
                return null;
                break;
        }
    }

    doesSupportFeedbackForms() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    getVideoModuleHeaderText() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return {
                    video: "video",
                    transcript: "interactive transcript",
                };
                break;
            case CURRENT_APP_LIVEPROJECT:
                return {
                    video: null,
                    transcript: "interactive transcript",
                };;
                break;
            default:
                return {
                    video: "video",
                    transcript: "interactive transcript",
                };
                break;
        }
    }



    getPrerequisitsTitle() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "prerequisites";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "who is this project for?";
                break;
            default:
                return "prerequisites";
                break;
        }
    }

    isThereCompletedInToc() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    doesTrackLiveBookViewer() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    numberingForTocUnits() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    enablePreviewFlagInMainToc() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    showTocTerminology() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    tocTerminology() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "table of contents";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "project outline";
                break;
            default:
                return "table of contents";
                break;
        }
    }

    doesSupportSimultaneouslyOpenDiscussionsAndToC() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    shouldDisableCloseInDiscussions() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    doesForceOpenDiscussions() { //Only if doesSupportSimultaneouslyOpenDiscussionsAndToC true
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return false;
                break;
        }
    }

    doesHaveRequestSupport() { //Only if doesSupportSimultaneouslyOpenDiscussionsAndToC true
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false;
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    getURLPartForOwnedProduct() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return "course";
                break;
            case CURRENT_APP_LIVEPROJECT:
                return "project";
                break;
            default:
                return "course";
                break;
        }
    }

    doesSupportSetIsInLibraryAndProduct() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return true
                break;
            case CURRENT_APP_LIVEPROJECT:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    doesHaveAddDefaultQuestionsButtonInEditCourse() {
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                return false
                break;
            case CURRENT_APP_LIVEPROJECT:
                return true;
                break;
            default:
                return true;
                break;
        }
    }

    obtainCourseCoverDimensions(): ICourseCoverDimensions {
        let dimensions: ICourseCoverDimensions;
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                dimensions = {
                    width: 180,
                    height: 225,
                    width2x: 360,
                    height2x: 450,
                    manageGroupsWidth: 180,
                    manageGroupsHeight: 225,
                    manageCoursesWidth: 100,
                    manageCoursesHeight: 125,
                }
                return dimensions;
                break;
            case CURRENT_APP_LIVEPROJECT:
                dimensions = {
                    width: 180,
                    height: 180,
                    width2x: 360,
                    height2x: 360,
                    manageGroupsWidth: 180,
                    manageGroupsHeight: 180,
                    manageCoursesWidth: 100,
                    manageCoursesHeight: 100,
                }
                return dimensions;
                break;
            default:
                dimensions = {
                    width: 180,
                    height: 225,
                    width2x: 180,
                    height2x: 450,
                    manageGroupsWidth: 180,
                    manageGroupsHeight: 225,
                    manageCoursesWidth: 100,
                    manageCoursesHeight: 125,
                }
                return dimensions;
                break;
        }
    }

    shouldDisplayUserVideoOptionsIfNotVideoModule() {
        let options;
        switch (this.currentApp) {
            case CURRENT_APP_LIVEVIDEO:
                options = {
                    transcriptHighlightingVisible: true,
                    pausingVisible: true,
                    playbackOptionsVisible: true,
                    speedOptionsVisible: true,
                }
                return options;
                break;
            case CURRENT_APP_LIVEPROJECT:
                options = {
                    transcriptHighlightingVisible: true,
                    pausingVisible: true,
                    playbackOptionsVisible: true,
                    speedOptionsVisible: true,
                }
                return options;
                break;
            default:
                options = {
                    transcriptHighlightingVisible: true,
                    pausingVisible: true,
                    playbackOptionsVisible: true,
                    speedOptionsVisible: true,
                }
                return options;
                break;
        }
    }

    doesShowPubliclyHiddenExercisesBasedOnGivenLicence(licenseTier) {
        if (this.doesSupportCertificateTestModule()) {
            switch (licenseTier) {
                case SOLO:
                    return false;
                case MENTORED:
                    return false;
                default:
                    return false;
            }
        } else {
            return false;
        }
    }

    shouldGrantAccessForTheAuthor(isEditingAccess, userRoles, courseId, authoredCourses, isPublished = true) {
        if (!userRoles.some(role => role === ROLE_IVC_AUTHOR)) return false;
        else {
            const isAuthorForCourse = authoredCourses?.some(id => +id == +courseId);
            if(!isAuthorForCourse) return false;
            else{
                if(isEditingAccess) return !isPublished;
                else return true;
            }
        }
    }


    shouldShowCertificateFeatures() {
        return false;
    }
}

export default new PlatformUtils();


/*
switch (this.currentApp) {
    case CURRENT_APP_LIVEVIDEO:

        break;
    case CURRENT_APP_LIVEPROJECT:

        break;
    default:
        break;
}
*/